module.exports = __webpack_public_path__ + "static/bannner-internacionalismo-10-7491929ac53a62a786535bf4c5e64249.jpeg";